import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { CurrentUserService } from 'src/app/shared/services/current-user.service';
import { UserAccessService } from '../userAccess.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-logged-in-as',
  templateUrl: './logged-in-as.component.html',
  styleUrls: ['./logged-in-as.component.scss']
})
export class LoggedInAsComponent implements OnInit, AfterViewInit, OnDestroy {
  userProfile: any = {};
  accessSummary: any;
  private subs = new Subscription();


  constructor(
    public currentUserService: CurrentUserService,
    private userAccessService: UserAccessService) { }

  /** Expose a simple snapshot for template bindings (template expects `currentUser.*`) */
  get currentUser(): any {
    return this.currentUserService.getSnapshot() || { isAuthenticated: false };
  }

  //constructor(@Inject('OidcManager') private oidcManager: any) { }

  ngOnInit(): void {
    // Initialise and subscribe to the current user. init() is idempotent.
    this.subs.add(
      this.currentUserService.init().subscribe(u => {
        if (!u) {
          this.userProfile = {};
          return;
        }

        this.userProfile = {
          given_name: u.firstName,
          family_name: u.lastName,
          name: u.name,
          email: u.email,
          isAuthenticated: u.isAuthenticated,
        };
      })
    );

    // fetch Access Summary from the BFF (use api prefix)
    // this.accessSummary$ = this.accessSummaryService.getAccessSummary();

    // since the oidcManager is no longer used directly, we must
    // hold onto the userProfile in a different way.
    // The best way is probably to  cache the profile in a service
    // and periodically check that the session is still active
    //this.oidcManager.manager.getUser()
    //  .then(u => {
    //    this.userProfile = u.profile;
    //  });
  }

  ngAfterViewInit() {
    this.subs.add(
      this.userAccessService
        .getAccessSummary()
        .subscribe(a => {
          this.accessSummary = a.data;
        })
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}



